import {
  CreateButton,
  DeleteButton,
  EditButton,
  ExportButton,
  getDefaultSortOrder,
  List,
  ShowButton,
  TextField,
  useTable,
} from "@refinedev/antd";

import { Divider, Space, Table, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { IResourceComponentsProps, useExport } from "@refinedev/core";
import { ICurrency } from "interfaces";
import React from "react";

export const CurrencyList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps, sorters, tableQuery: { isLoading } } = useTable<ICurrency>({
    sorters: {
      initial: [
        {
          field: "id",
          order: "desc",
        },
      ]
    }
  });

  const { triggerExport, isLoading: isLoadingExport } = useExport<ICurrency>({
    mapData: (item) => {
      return {
        "Currency Name": item?.name || "",
        "Currency Code": item?.code || "",
        "Currency Symbol": item?.symbol || "",
      };
    },
    unparseConfig: {
      header: true,
      columns: ["Currency Name", "Currency Code", "Currency Symbol"],
    },
  });

  const columns: ColumnsType<ICurrency> = [
    {
      title: "Currency Name",
      dataIndex: "name",
      key: "name",
      width: 200,
      className: "wrap-text",
      render: (value) => <TextField value={value} />,
      defaultSortOrder: getDefaultSortOrder("name", sorters),
      sorter: true,
    },
    {
      title: "Currency Code",
      dataIndex: "code",
      key: "code",
      width: 120,
      render: (value) => <TextField value={value} />,
      defaultSortOrder: getDefaultSortOrder("code", sorters),
      sorter: true,
    },
    {
      title: "Currency Symbol",
      dataIndex: "symbol",
      key: "symbol",
      width: 120,
      render: (value) => <TextField value={value} />,
      defaultSortOrder: getDefaultSortOrder("symbol", sorters),
      sorter: true,
    },
    {
      title: "Actions",
      key: "actions",
      fixed: "right",
      width: 120,
      render: (_, record) => (
        <Space>
          <EditButton hideText size="small" recordItemId={record.id} />
          <ShowButton hideText size="small" recordItemId={record.id} />
          <DeleteButton hideText size="small" recordItemId={record.id} />
        </Space>
      ),
    },
  ];

  return (
    <List
      breadcrumb={false}
      headerProps={{
        // onBack: () => window.history.back(),
        subTitle: "active currencies",
        tags: isLoading ? (
          <Tag color="orange">loading</Tag>
        ) : (
          <Tag color="green">live</Tag>
        ),
        extra: (
          <React.Fragment>
            <Space>
              <CreateButton />
              <ExportButton onClick={triggerExport} loading={isLoadingExport} />
            </Space>
          </React.Fragment>
        ),
        ghost: true,
        footer: (
          <Divider plain>
            © {new Date().getFullYear()} e-Mariner NavSolutions
          </Divider>
        ),
      }}
    >
      <Table
        {...tableProps}
        columns={columns}
        rowKey="id"
        size="middle"
        scroll={{ x: 1200 }}
        sticky
        pagination={{
          ...tableProps.pagination,
          showSizeChanger: true,
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
        }}
      />
    </List>
  );
};
